import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

import {
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

interface Parameter {
    productId: string;
    relatedProductType: string;
    pageSize?: number;
}

interface Props {
    apiParameter?: GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter;
    products?: any[];
    error?: any;
}

type HandlerType = Handler<Parameter, Props>;

export const BuildApiParameter: HandlerType = props => {
    const { productId, relatedProductType, pageSize } = props.parameter;

    props.apiParameter = {
        productId,
        relationship: relatedProductType,
        sort: productId,
        pageSize: pageSize || 999,
    };
};

export const CallApi: HandlerType = ({ dispatch, apiParameter }) => {
    if (!apiParameter) {
        return;
    }
    dispatch(
        loadProductInfoList({
            id: "isAccessoryOrSparePartFor",
            getProductCollectionParameter: apiParameter,
        }),
    );
};

export const chain = [BuildApiParameter, CallApi];

const loadCustomRelatedProducts = createHandlerChainRunner(chain, "LoadCustomRelatedProducts");

export default loadCustomRelatedProducts;
